var map = {
	"./accounting.svg": "1e10",
	"./cart.svg": "daca",
	"./chevronDown.svg": "bb16",
	"./chevronLeft.svg": "a7a4",
	"./chevronRight.svg": "8dc6",
	"./close.svg": "8b1b",
	"./closeBlack.svg": "16ff",
	"./facebook.svg": "8485",
	"./linkedin.svg": "9ed9",
	"./list.svg": "99ad",
	"./lock.svg": "9619",
	"./login-close.png": "29c6",
	"./menu.svg": "d17f",
	"./money.svg": "cf44",
	"./orderCart.svg": "0fe3",
	"./orderConfirm.svg": "4682",
	"./packaging.svg": "b90a",
	"./register1.svg": "4862",
	"./register2.svg": "aee6",
	"./register3.svg": "ab3b",
	"./register4.svg": "c285",
	"./search.svg": "d103",
	"./sourcingReport.svg": "fa82",
	"./specification.svg": "b484",
	"./spinner.svg": "1461",
	"./uploadBlack.svg": "3a11",
	"./usa.svg": "e038",
	"./user.svg": "6aed",
	"./value1.svg": "98e6",
	"./value2.svg": "1b62",
	"./value3.svg": "ac64",
	"./value4.svg": "a09a",
	"./website.svg": "7824"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";